<template>
            <div>
                <span class=" hover:animate-shake inline-flex items-center rounded-md bg-yellow-50 px-2.5 py-0.5 text-sm font-medium text-yellow-800">Admin</span>
            </div>
</template>